import { createSlice } from "@reduxjs/toolkit";
import {
    getNotes,
    addNotes,
    updateNotes,
    deleteNotes,
    getDraftNotes,
    saveDraft,
    getNoteHistory,
    getUserNotesHistory,
    getCompanyNotesHistory,
} from './thunk';

export const initialState = {
    notes: [],
    draftNotes: [],
    noteHistory: [],
    userNotesHistory: [],
    companyNotesHistory: [],
    error: null,
    loading: false
};

const NotesSlice = createSlice({
    name: 'Notes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotes.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getNotes.fulfilled, (state: any, action: any) => {
            state.notes = action.payload;
            state.loading = false;
        });
        builder.addCase(getNotes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.loading = false;
        });
        builder.addCase(addNotes.fulfilled, (state: any, action: any) => {
            state.notes.unshift(action.payload);
        });
        builder.addCase(addNotes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        builder.addCase(updateNotes.fulfilled, (state: any, action: any) => {
            state.notes = state.notes.map((notes: any) =>
                notes.id === action.payload.id
                    ? { ...notes, ...action.payload }
                    : notes
            );
        });
        builder.addCase(updateNotes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        builder.addCase(deleteNotes.fulfilled, (state: any, action: any) => {
            state.notes = state.notes.filter(
                (notes: any) => notes.id !== action.payload
            );
        });
        builder.addCase(deleteNotes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        builder.addCase(getDraftNotes.fulfilled, (state: any, action: any) => {
            state.draftNotes = action.payload;
        });
        builder.addCase(saveDraft.fulfilled, (state: any, action: any) => {
            // Draft saved successfully
        });
        builder.addCase(saveDraft.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        builder.addCase(getNoteHistory.fulfilled, (state: any, action: any) => {
            state.noteHistory = action.payload;
        });
        builder.addCase(getUserNotesHistory.fulfilled, (state: any, action: any) => {
            state.userNotesHistory = action.payload;
        });
        builder.addCase(getCompanyNotesHistory.fulfilled, (state: any, action: any) => {
            state.companyNotesHistory = action.payload;
        });
    }
});

export default NotesSlice.reducer;